
import { datadogRum } from '@datadog/browser-rum'
import { startRum } from '@/monitoring/datadogRum'

// Published so code in other entrypoints can reach the *initialised* SDK — see
// reportError in @/monitoring/datadogRum. Importing @datadog/browser-rum from
// another pack yields a separate, un-init'd module instance instead.
window.DD_RUM = datadogRum

// Boot here, not from an inline <script> in the view: this pack's <script> is
// emitted by the single javascript_pack_tag in layouts/_head, below the partial
// that renders the config, so an inline initialiser runs before DD_RUM exists.
startRum(datadogRum)

